import api from "../axiosIntercepture";


export const getNextWorkstationId = async () => {
    const response = await api.post("workstation/next-id");

    if (response.data?.success) {
        return response.data.data.workstationId;
    }

    throw new Error(response.data?.message || "Failed to fetch Workstation ID");
};



export const searchLocation = async (query) => {

    const response = await api.post(
        `ordermanagement/searchLocation?query=${query}`
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message);
    }

    return response.data.data;
};

export const fetchWorkstation = async (page = 0, pageSize = 10) => {

    const response = await api.post("workstation/fetch", {
        page: page + 1,
        limit: pageSize
    });

    if (!response.data?.success) {
        throw new Error(response.data?.message || "Failed to fetch Workstation");
    }

    return response.data.data;
};


export const fetchWorkstationById = async (id) => {

    const response = await api.post("workstation/fetch", { id });

    if (!response.data?.success) {
        throw new Error(response.data?.message || "Failed to fetch Workstation");
    }

    return response.data.data;
};


export const createWorkstation = async (payload) => {

    const response = await api.post("workstation/create", payload);

    if (!response.data?.success) {
        throw new Error(response.data?.message || "Failed to create Workstation");
    }

    return response.data.data;
};


export const updateWorkstation = async (id, payload) => {

    if (!id) throw new Error("Missing Workstation ID");

    const response = await api.post(
        `workstation/update/${encodeURIComponent(id)}`,
        payload
    );

    if (!response.data?.success) {
        throw new Error(response.data?.message || "Failed to update Workstation");
    }

    return response.data.data;
};